
import Header from "../home/components/Header";
import Footer from "../home/components/Footer";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      
      <main className="flex-1 px-6 py-16 md:py-24">
        <div className="max-w-[800px] mx-auto text-left">
          <h1 className="text-3xl md:text-4xl font-bold text-[#5A4033] mb-12">
            プライバシーポリシー
          </h1>

          <div className="space-y-8 text-base text-[#5A4033] leading-relaxed">
            <p>
              おうちの相談室(以下、「当サービス」といいます)は、<br />
              本ウェブサイト上で提供するサービスにおいて、<br />
              ユーザーの個人情報の取扱いについて、<br />
              以下のとおりプライバシーポリシーを定めます。
            </p>

            <div>
              <h2 className="text-xl font-bold text-[#5A4033] mb-4">
                【個人情報の取得について】
              </h2>
              <p>
                当サービスでは、お問い合わせやご相談の際に、<br />
                氏名、メールアドレス、LINEアカウント情報などの<br />
                個人情報をご提供いただく場合があります。
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-[#5A4033] mb-4">
                【個人情報の利用目的】
              </h2>
              <p>
                取得した個人情報は、以下の目的のために利用します。<br />
                ・ご相談、ご質問への対応<br />
                ・サービス提供に伴う連絡<br />
                ・必要に応じたご案内や情報提供
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-[#5A4033] mb-4">
                【個人情報の第三者提供について】
              </h2>
              <p>
                法令に基づく場合を除き、<br />
                ご本人の同意なく第三者に個人情報を提供することはありません。
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-[#5A4033] mb-4">
                【個人情報の管理】
              </h2>
              <p>
                当サービスは、個人情報を適切に管理し、<br />
                漏えい、改ざん、不正アクセス等の防止に努めます。
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-[#5A4033] mb-4">
                【外部サービスの利用について】
              </h2>
              <p>
                当サービスでは、LINE公式アカウント等の外部サービスを利用する場合があります。<br />
                また、サービス向上および利用状況把握のため、<br />
                アクセス解析ツールを使用する場合があります。<br />
                これらのツールではCookieを利用することがありますが、<br />
                個人を特定する情報は含まれません。
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-[#5A4033] mb-4">
                【免責事項】
              </h2>
              <p>
                当サービスは、住宅購入や契約の成立を保証するものではありません。<br />
                最終的な判断および意思決定は、<br />
                お客様ご自身の責任において行われるものとします。
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-[#5A4033] mb-4">
                【プライバシーポリシーの変更】
              </h2>
              <p>
                本ポリシーの内容は、必要に応じて変更されることがあります。<br />
                変更後の内容は、本ページにて速やかに公開します。
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-[#5A4033] mb-4">
                【お問い合わせ窓口】
              </h2>
              <p>
                個人情報の取扱いに関するお問い合わせは、<br />
                当サービスのお問い合わせ窓口までご連絡ください。
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
